import { FlowModuleItemType } from "@packages/flow-core/module";
import NodeCard from "../NodeCard";
import { NodeProps } from "reactflow";
import { memo, useEffect, useMemo } from "react";
import Divider from "../Divider";
import RenderInput from "../render/RenderInput";
import styles from "./index.less";
import TextInput from "../render/RenderInput/templates/TextInput";
import Select from "../render/RenderInput/templates/Select";
import { useFlow } from "../FlowEdit/useFlow";
import RenderOutput from "../render/RenderOutput";

const CustomComponent = {
  groupName: TextInput,
  otherUserIds: Select,
  targetGroupIds: Select,
};

export default memo(function NodePullGroup({
  selected,
  data,
}: NodeProps<FlowModuleItemType>) {
  const { inputs, moduleId, outputs } = data;
  const { updateModuleInput, getNode } = useFlow();

  const visibleInputs = useMemo(() => {
    return inputs.filter((input) => !input.hideInApp);
  }, [inputs]);

  const modeInput = getNode(moduleId, "pullGroupMode")!;

  useEffect(() => {
    const groupNameInput = getNode(moduleId, "groupName")!;
    const otherUserIdsInput = getNode(moduleId, "otherUserIds")!;
    const targetGroupIdsInput = getNode(moduleId, "targetGroupIds")!;

    if (modeInput.value === 1) {
      updateModuleInput(moduleId, groupNameInput.key, {
        ...groupNameInput,
        hideInApp: false,
      });
      updateModuleInput(moduleId, otherUserIdsInput.key, {
        ...otherUserIdsInput,
        hideInApp: false,
        required: false,
      });
      updateModuleInput(moduleId, targetGroupIdsInput.key, {
        ...targetGroupIdsInput,
        hideInApp: true,
        required: false,
      });
      false;
    } else {
      updateModuleInput(moduleId, groupNameInput.key, {
        ...groupNameInput,
        hideInApp: true,
      });
      updateModuleInput(moduleId, otherUserIdsInput.key, {
        ...otherUserIdsInput,
        hideInApp: true,
        required: false,
      });
      updateModuleInput(moduleId, targetGroupIdsInput.key, {
        ...targetGroupIdsInput,
        hideInApp: false,
        required: false,
      });
    }
  }, [modeInput.value]);

  return (
    <NodeCard {...data} selected={selected}>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderInput
          flowInputList={visibleInputs}
          moduleId={moduleId}
          CustomComponent={CustomComponent}
        />
      </div>
      <Divider text="输入" />
      <div className={styles.content}>
        <RenderOutput moduleId={moduleId} flowOutputList={outputs} />
      </div>
    </NodeCard>
  );
});
